export default __webpack_public_path__ + "static/media/petful-screenshot.a777b677.png";